<template>
    <v-app-bar class="toolbar-box" 
      color="primary"
      app
      fixed
      shrink-on-scroll
      :max-height="headerHeight"
      :height="headerHeight"
      :min-height="56"
      fade-img-on-scroll
      :scroll-threshold="headerHeight/2"
      src="@/assets/img/banner.jpg">

      <div class="tool-box">
        <v-app-bar-nav-icon class="nav-icon-box" color="white" @click="showMenu()">
          <v-icon large class="menu-icon">
            mdi-menu
          </v-icon>
        </v-app-bar-nav-icon>
        <div class="app-title">École de brens</div>
      </div>
      

    </v-app-bar>
</template>

<style scoped>
  @import '../assets/styles/global-styles.css';
  @import '../assets/styles/variables.css';

  .tool-box {
    padding: 7px;
    height: 100%;
    max-height: 56px;
    width: 100%;
    position: relative;
  }

  .app-title {
    margin-left: auto;
    margin-right: auto;
    font-size: 1.1em;
    text-align: center;
    color: white;
    font-weight: bold;

    text-shadow: 0 0 5px #1a1a3bb4, 
    -2px -2px 0 var(--primary-background-color),
      2px -2px 0 var(--primary-background-color),
       -2px 2px 0 var(--primary-background-color),
        2px 2px 0 var(--primary-background-color);
  }


  .nav-icon-box {
    position: absolute;
    margin-top: auto;
    margin-bottom: auto;
    top: 3px;
    left: 8px;
    background-color: var(--primary-background-color) !important;
    box-shadow: 0 0 3px var(--primary-background-color-translucent) !important;
  }

  .nav-icon {
    color: white;
    text-shadow: 0 0 4px rgba(26, 26, 59, 0.959), 0 0 2px black, 0 0 1px black;
  }

</style>


<script lang="ts">
  import { Component, Prop, Vue } from 'vue-property-decorator';
  import MobileNavigationMenu from './MobileNavigationMenu.component.vue';

  const imgHeight = 275;
  const imgWidth = 787;

  /**
   * @desc boite d'outils en-tête pour l'affichage mobile du site
   */
  @Component({
    components: {
      'mobile-navigation-menu' : MobileNavigationMenu
    },
  })
  export default class MobileToolbar extends Vue {
    /**
     * @desc la hauteur de la boite à afficher
     */
    @Prop()
    headerHeight?: number;

    menuVisible = false;

    /**
     * @desc demande l'affichage du menu de navigation
     */
    private showMenu() : void {
      this.$root.$emit('show-menu', true);
    }
  }

</script>
